import { Breakpoint } from '@lendi-ui/breakpoint';

const convertToPixels = (breakpointSize: string) => {
  const emUnits = Number.parseInt(breakpointSize.replace('em', ''));
  const fontSize =
    Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue('--lendi-ui-size')) || 16;
  return emUnits * fontSize;
};

// Functions so that they can recalculate if the --lendi-ui-size variable changes
export const minWidthMobile = () => convertToPixels(Breakpoint.xs);
export const minWidthTablet = () => convertToPixels(Breakpoint.sm);
export const minWidthDesktop = () => convertToPixels(Breakpoint.xl);

export enum DEVICE_TYPE {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
}
